import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'

export const fulfillmentConfigurationsPageAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.deliveryOrchestration],
  warehouseFeatureToggles: [FeatureToggle.deliveryOrchestration],
}
